import { Injectable } from '@angular/core';
import { environment } from '../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { map,timeout } from "rxjs/operators";
import { Observable } from 'rxjs';
import { BBResponseContainer } from '../common-services/response-container';

@Injectable({
  providedIn: 'root'
})
export class LibprepWorkfilesService {

  readonly LIB_PREP_SERVICE='/worklist/libPrepworkfile/'
  constructor(private http: HttpClient) {
  }

  getWorkFileList(request: any) :Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + this.LIB_PREP_SERVICE +"list";
    return this.http.put<any>(url, request).pipe(timeout(environment.defaultTimeout));
  }
  downloadFilesFromAzure(labName: string,fileName: string) {
  const url = `${environment.BB_NGS_LIB_PREP_URL}${this.LIB_PREP_SERVICE}getFileName/${labName}/${fileName}`;
  return this.http.get(url, { observe: 'response', responseType: 'blob'}).pipe(
    map((res) => {
      return {
        fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
        filename: res.headers.get('filename')
      }
    })
    );
  }
}
